import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <div className="relative flex flex-row justify-between items-center w-full h-[100px] lg:h-auto px-[8%] lg:py-5 2xl:py-[2%] py-3 overflow-hidden border-t-[1.5px] border-[#081D8D]">
            <Link to="/" className='w-32 h-6 lg:w-52 lg:h-8 2xl:w-60 2xl:h-9'>
                <img src="/logo.webp" alt="logo" className="z-20 w-32 h-6 lg:w-52 lg:h-8 2xl:w-60 2xl:h-9" />
            </Link>
            <div className="flex flex-col justify-between items-start z-20 gap-4 w-[50%]">
                <Link to="/" className="text-[#081D8D] text-[8px] lg:text-base 2xl:text-lg lg:font-medium text-right hover:font-bold  transition-all duration-300 ease-in-out">
                    Главная
                </Link>
                <Link to="/products" className="text-[#081D8D] text-[8px] lg:text-base 2xl:text-lg lg:font-medium text-right hover:font-bold transition-all duration-300 ease-in-out">
                    Проекты
                </Link>
                <Link to="/contacts" className="text-[#081D8D] text-[8px] lg:text-base 2xl:text-lg lg:font-medium text-right hover:font-bold transition-all duration-300 ease-in-out">
                    Контакты
                </Link>
            </div>
            <div className="flex flex-col justify-between z-20 gap-4">
                <p className="text-[#081D8D] text-[7px] lg:text-sm 2xl:text-base lg:font-medium">
                    <span className="font-medium lg:font-medium">Тел: </span>
                    <a href="tel:+79524030253" className="hover:underline underline-offset-2">+7(952)-403-02-53</a>
                </p>

                <p className="text-[#081D8D] text-[7px] lg:text-sm 2xl:text-base lg:font-medium">
                    <span className="font-medium lg:font-medium">Email: </span>
                    <a href="mailto:turtton@yandex.ru" className="hover:underline underline-offset-2">turtton@yandex.ru</a>
                </p>

                <p className="text-[#081D8D] text-[7px] lg:text-sm 2xl:text-base lg:font-medium">
                    <span className="font-medium lg:font-medium">Адрес: </span>
                    <a
                        href="https://yandex.ru/maps/-/CHASRQM9"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline underline-offset-2"
                    >
                        г.Ижевск, ул. Холмогорова, д. 43
                    </a>
                </p>
            </div>
        </div>
    );
}
